export enum FiacaoTipo {
  EMBUTIDA = 'EMBUTIDA',
  EXPOSTA = 'EXPOSTA',
}
